import { css } from '@mui/material';

export const useStyles = () => {
  return {
    analyticContainer: css`
      display: flex;
      flex-direction: column;
      flex: 1;
      padding-top: 20px;
      padding-right: 10px;
      min-height: 100vh;

      @media (max-width: 1024px) {
        padding: 16px;
      }
    `,
    analyticHeader: css`
      padding: 23px 40px;
      border-radius: 20px;
      background: #ffffff;
      box-shadow: 0 0 20px 0 #0000000d;
      margin-bottom: 32px;
    `,

    filterContainer: css`
      display: grid;
      grid-template-columns:
        minmax(148px, 1fr) minmax(256px, 1fr) minmax(174px, 1fr) minmax(145px, 1fr) minmax(120px, 1fr)
        minmax(120px, 1fr);
      gap: 12px;
      margin-bottom: 28px;

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
        flex-wrap: wrap;
        gap: 4px;
      }
    `,

    cardsContainer: css`
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 12px;

      @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }
    `,

    mainGraphContainer: (isLoading: boolean) => css`
      margin: 28px 0 20px;
      padding: 24px;
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0 20px 0 #0000000d;
      opacity: ${isLoading ? 0.4 : 1};
      position: relative;
      pointer-events: ${isLoading ? 'none' : 'auto'};
    `,
    fetchingIndicator: css`
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    `,

    mainGraphHeader: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
    `,
    loadingGraphWrapper: css`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 201px;
    `,

    dateContainer: css`
      display: flex;
      padding: 2px 12px;
      gap: 3px;
    `,

    mainGraphEmpty: css`
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 8px;
    `,

    circlesCardsContainer: css`
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 12px;
      margin-bottom: 20px;

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
      }
    `,
  };
};
